import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, Outlet } from 'react-router-dom';

const ROLES_CLAIM = 'https://raah-portal.com/roles';

function AdminRoute() {
  const { isAuthenticated, isLoading, user } = useAuth0();

  if (isLoading) return null;

  const roles = user?.[ROLES_CLAIM] || [];
  const isAdmin = roles.includes('Partner Portal Admin');

  if (!isAuthenticated || !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export default AdminRoute;